"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Spinner = function Spinner(_ref) {
  var className = _ref.className,
    scale = _ref.scale,
    style = _ref.style,
    text = _ref.text,
    textStyle = _ref.textStyle,
    center = _ref.center;
  var centerStyles = center ? ['flex', 'justify-center', 'h-full', 'items-center'] : [];
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-label": "Loading",
    "aria-live": "polite",
    className: (0, _classnames["default"])('spinner-container', centerStyles, className),
    style: {
      transform: "scale(".concat(scale, ")")
    }
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "spinner",
    style: style,
    width: "66px",
    height: "66px",
    viewBox: "0 0 66 66"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    className: "path",
    fill: "none",
    strokeWidth: "6px",
    strokeLinecap: "round",
    cx: "33",
    cy: "33",
    r: "30"
  })), text && /*#__PURE__*/_react["default"].createElement("h4", {
    style: textStyle
  }, text));
};
Spinner.propTypes = {
  className: _propTypes["default"].string,
  scale: _propTypes["default"].number,
  style: _propTypes["default"].object,
  text: _propTypes["default"].string,
  textStyle: _propTypes["default"].object,
  center: _propTypes["default"].bool
};
Spinner.defaultProps = {
  className: '',
  scale: 1,
  style: {},
  text: '',
  textStyle: {},
  center: false
};
var _default = exports["default"] = Spinner;